import React from "react";
import "./../AllRightReserved/RightReservedStyle.css";
function RightReserved() {
  return (
    <div className="m-0 p-0">
      <div className="d-flex justify-content-center mt-4">
        <p className="footer_right_reserved">
          © 2023 PPC Leads to Deal. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default RightReserved;
